module.exports = __webpack_public_path__ + "static/media/film-alt.2bd23aa1.svg";